//#region INTERFACE INgpReportRow

/**
 * ### INgpReportRow
 * Row shape consumed by the Auto Ordering NGP Report modal grid.
 *
 * @interface INgpReportRow
 * @description Flat, grid-friendly projection of an ordered stock item used to render
 *              the rows in `AutoOrderingNgpReportModalComponent`. The component composes
 *              each row from the corresponding `AOStockInfo`, the current order quantity,
 *              and any in-flight cost edits before passing it to AG Grid.
 *
 * @property {string} code - Stock item code, also used as the row identity key.
 * @property {Date | null} lastSold - Date the item was last sold, when available.
 * @property {Date | null} lastStockTake - Date of the most recent stock take, when available.
 * @property {number} latestCost - Latest cost price (may reflect an in-flight cost edit).
 * @property {number} lineColourCode - Visual line colour code applied to the row.
 * @property {Date | null} modified - Date the underlying item record was last modified.
 * @property {number} onHand - Current on-hand quantity.
 * @property {number} onHoldCode - On-hold status code for the item.
 * @property {number} ordLvl - Configured re-order level.
 * @property {number} orderQty - Quantity currently planned to order.
 * @property {number} packSize - Pack size for the item.
 * @property {number} prevGp - Previous gross profit percentage.
 * @property {number} purchaseOrder - Outstanding purchase order quantity.
 * @property {string} regularSuppCode - Regular (preferred) supplier code.
 * @property {string} suppCode - Supplier code linked to the current order line.
 * @property {number} unitsYear - Units sold over the trailing twelve months.
 */
export interface INgpReportRow {
  code: string;
  lastSold: Date | null;
  lastStockTake: Date | null;
  latestCost: number;
  lineColourCode: number;
  modified: Date | null;
  onHand: number;
  onHoldCode: number;
  ordLvl: number;
  orderQty: number;
  packSize: number;
  prevGp: number;
  purchaseOrder: number;
  regularSuppCode: string;
  suppCode: string;
  unitsYear: number;
}

//#endregion
